import { AnyExtension } from '@tiptap/core';
import { CodeBlock } from '@tiptap/extension-code-block';
import { BlockNodes } from '../../available-extensions';

export function createCodeBlockExtension(): AnyExtension {
  return CodeBlock.extend({
    name: BlockNodes.CodeBlock,
  });
}
